'use strict';
const angular = require('angular');
import MonthlyReportController from './monthlyReport.controller';
import routes from './monthlyReport.routes';
import reportRow from './directives/reportRow';

export default angular.module('nomasvelloDashboardApp.monthlyReport', [
    reportRow
])
    .config(routes)
    .controller('MonthlyReportController', MonthlyReportController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/monthlyReport/index.ts